import map from 'lodash-es/map';
import sortBy from 'lodash-es/sortBy';
import extend from 'lodash-es/extend';

import { IDaysData, IDay } from '@df/catalog/store/store';

import { jsonStringToDate } from '@df/util/fn/json-string-to-date';

export function getOpeningHours(days: IDaysData): IDay[] {
    const startOfToday = new Date();
    startOfToday.setHours(0, 0, 0, 0);

    return sortBy(
        map(days, (day, date) => {
            return extend({ date: jsonStringToDate(date) }, day) as IDay;
        }).filter(day => day.date && day.date >= startOfToday),
        day => {
            if (day.date) {
                return day.date.getTime();
            }
            return false;
        }
    );
}
